export default "__VITE_ASSET__2VhmDwQk__"